import { render, staticRenderFns } from "./ReservationConfirm.vue?vue&type=template&id=72e9b330&scoped=true&"
import script from "./ReservationConfirm.vue?vue&type=script&lang=ts&"
export * from "./ReservationConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ReservationConfirm.vue?vue&type=style&index=0&id=72e9b330&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9b330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VRow})
